// Take components in the array that are between
// the components with the start name and the end name,
// add them as inner components to the start name component,
// and delete them from the original array
const nestInnerMarkupComponents = (
  originalMarkupComponents: any[] = [],
  startComponentName: string,
  endComponentName: string,
) => {
  // This is to avoid duplicates that happen when the code
  // is processed twice, server and client side?
  const components = originalMarkupComponents.filter(
    (component: any) => !component.markedForDelete,
  );

  for (const component of components) {
    if (component.Component.toLowerCase() === startComponentName) {
      const startComponentIndex = components.indexOf(component);
      const nextComponentIdx = startComponentIndex + 1;

      for (let i = nextComponentIdx; i <= components.length; i++) {
        if (components[i].Component.toLowerCase() === endComponentName) {
          break;
        }

        if (!component.innerMarkup) {
          component.innerMarkup = [];
        }

        component.innerMarkup.push({ ...components[i] });
        components[i].markedForDelete = true;
      }
    }
  }

  return components.filter((component: any) => !component.markedForDelete);
};

export { nestInnerMarkupComponents };
